import React from 'react';
import './ExportButtons.css';

/**
 * Reusable export buttons component for all leaderboard boards
 */

export interface ExportButtonsProps {
  onExportCSV: () => void;
  onExportPDF: () => void;
  disabled?: boolean;
  className?: string;
}

const ExportButtons: React.FC<ExportButtonsProps> = ({
  onExportCSV,
  onExportPDF,
  disabled = false,
  className = ''
}) => {
  return (
    <div className={`export-buttons ${className}`}>
      <button
        onClick={onExportCSV}
        disabled={disabled}
        className="export-button export-csv"
        title="Export data to CSV file"
      >
        <span className="export-icon">📊</span>
        <span className="export-label">CSV</span>
      </button>
      
      <button
        onClick={onExportPDF}
        disabled={disabled}
        className="export-button export-pdf"
        title="Export data to PDF file"
      >
        <span className="export-icon">📄</span>
        <span className="export-label">PDF</span>
      </button>
    </div>
  );
};

export default ExportButtons;
